/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { CityModel } from '../entities/CityModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const cityModelSchema = z.object({
  drivee_id: z.number().int(),
  id: z.string(),
  name: z.string(),
}) as unknown as ToZod<CityModel>